const NaoResidencial = () => {
    return <h1>Não-Residencial</h1>;
  };
  
  export default NaoResidencial;